import React from "react";
import BlockRenderer from "./BlockRenderer";

export default function DragCanvas({ blocks, setBlocks }) {
  const deleteBlock = (index) => {
    setBlocks(blocks.filter((_, i) => i !== index));
  };

  return (
    <div className="drag-canvas">
      <h3 className="canvas-title">Page Canvas</h3>

      {blocks.length === 0 && (
        <p className="no-blocks">Drag a block from left panel</p>
      )}

      {blocks.map((block, index) => (
        <div key={index} className="canvas-block">
          <BlockRenderer block={block} />

          <button className="delete-block" onClick={() => deleteBlock(index)}>
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
